<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li  class="SideMenuLinksInner">
            <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
                <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
                <span>NFO</span>
            </a>
            </li> -->
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/forms"
              routerLinkActive="active">
              <!-- Commented by pradnesh 10/06/2025  -->
              <!-- <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" /> -->
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.46704 2.81543H9.20654C9.306 2.81543 9.40138 2.77592 9.47171 2.70559C9.54203 2.63527 9.58154 2.53989 9.58154 2.44043C9.58154 2.34097 9.54203 2.24559 9.47171 2.17526C9.40138 2.10494 9.306 2.06543 9.20654 2.06543H8.46704V2.81543Z" fill="#444444"/>
                  <path d="M6.56152 3.8268C6.86928 3.8268 7.11877 3.43251 7.11877 2.94612C7.11877 2.45973 6.86928 2.06543 6.56152 2.06543C6.25376 2.06543 6.00427 2.45973 6.00427 2.94612C6.00427 3.43251 6.25376 3.8268 6.56152 3.8268Z" fill="#444444"/>
                  <path d="M13.1064 0.5H2.89365C2.53477 0.5 2.24377 0.806938 2.24377 1.18531V14.8147C2.24377 15.1931 2.53477 15.5 2.89365 15.5H13.1064C13.4653 15.5 13.7563 15.1931 13.7563 14.8147V1.18531C13.7563 0.806938 13.4653 0.5 13.1064 0.5ZM8.09209 3.00275V1.87775C8.09209 1.82802 8.11184 1.78033 8.147 1.74517C8.18217 1.71 8.22986 1.69025 8.27959 1.69025H9.20659C9.3903 1.69036 9.56758 1.7579 9.7048 1.88005C9.84203 2.0022 9.92964 2.17047 9.95103 2.35293C9.97242 2.5354 9.92609 2.71936 9.82084 2.86994C9.71559 3.02051 9.55873 3.12722 9.38002 3.16981L9.92002 3.90313C9.93516 3.92291 9.9462 3.94551 9.9525 3.96961C9.9588 3.9937 9.96023 4.01882 9.95672 4.04348C9.95321 4.06813 9.94482 4.09185 9.93204 4.11323C9.91926 4.13461 9.90235 4.15323 9.8823 4.168C9.86225 4.18277 9.83945 4.1934 9.81524 4.19927C9.79103 4.20513 9.7659 4.20611 9.74131 4.20216C9.71672 4.1982 9.69316 4.18938 9.67201 4.17622C9.65087 4.16306 9.63256 4.14582 9.61815 4.1255L8.92946 3.19025H8.46709V4.01525C8.46709 4.06498 8.44733 4.11267 8.41217 4.14783C8.37701 4.183 8.32931 4.20275 8.27959 4.20275C8.22986 4.20275 8.18217 4.183 8.147 4.14783C8.11184 4.11267 8.09209 4.06498 8.09209 4.01525V3.00275ZM5.88127 2.08344C6.05809 1.82994 6.29959 1.68969 6.56171 1.68969C6.82384 1.68969 7.06534 1.82937 7.24215 2.08344C7.40452 2.31631 7.49396 2.62269 7.49396 2.94594C7.49396 3.26919 7.40452 3.57575 7.24215 3.80844C7.06534 4.06194 6.82365 4.20219 6.56171 4.20219C6.29977 4.20219 6.05809 4.0625 5.88127 3.80844C5.7189 3.57556 5.62946 3.26919 5.62946 2.94594C5.62946 2.62269 5.71871 2.31631 5.88127 2.08344ZM7.29802 5.39188V6.53563H3.72277V5.39188H7.29802ZM3.53527 4.01619V2.97088C3.53527 2.96525 3.53527 2.95981 3.53621 2.95437C3.53561 2.94883 3.5353 2.94326 3.53527 2.93769V1.89219C3.53527 1.77781 3.6309 1.68819 3.75315 1.68819H4.87384C4.92356 1.68819 4.97126 1.70794 5.00642 1.74311C5.04158 1.77827 5.06134 1.82596 5.06134 1.87569C5.06134 1.92542 5.04158 1.97311 5.00642 2.00827C4.97126 2.04343 4.92356 2.06319 4.87384 2.06319H3.91027V2.76687H4.87384C4.92356 2.76687 4.97126 2.78663 5.00642 2.82179C5.04158 2.85696 5.06134 2.90465 5.06134 2.95437C5.06134 3.0041 5.04158 3.05179 5.00642 3.08696C4.97126 3.12212 4.92356 3.14187 4.87384 3.14187H3.91009V4.01619C3.91009 4.06592 3.89033 4.11361 3.85517 4.14877C3.82001 4.18393 3.77231 4.20369 3.72259 4.20369C3.67286 4.20369 3.62517 4.18393 3.59 4.14877C3.55484 4.11361 3.53509 4.06592 3.53509 4.01619H3.53527ZM12.2773 14.0563H3.72277V12.9125H12.2773V14.0563ZM12.2773 11.5496H3.72277V10.4058H12.2773V11.5496ZM12.2773 9.04288H3.72277V7.89913H12.2773V9.04288ZM12.2773 6.53619H8.70202V5.39244H12.2773V6.53619ZM12.4648 4.01413C12.4648 4.06385 12.445 4.11154 12.4099 4.14671C12.3747 4.18187 12.327 4.20163 12.2773 4.20163C12.2275 4.20163 12.1799 4.18187 12.1447 4.14671C12.1095 4.11154 12.0898 4.06385 12.0898 4.01413V2.98025L11.7232 4.0265C11.7201 4.07409 11.699 4.1187 11.6642 4.15127C11.6293 4.18384 11.5834 4.20191 11.5357 4.20181H11.5284C11.4807 4.20191 11.4348 4.18384 11.3999 4.15127C11.3651 4.1187 11.344 4.07409 11.3409 4.0265L10.9743 2.98006V4.01431C10.9743 4.06404 10.9546 4.11173 10.9194 4.1469C10.8843 4.18206 10.8366 4.20181 10.7868 4.20181C10.7371 4.20181 10.6894 4.18206 10.6543 4.1469C10.6191 4.11173 10.5993 4.06404 10.5993 4.01431V1.87681C10.5993 1.83251 10.6149 1.78962 10.6435 1.75575C10.6721 1.72187 10.7117 1.69921 10.7554 1.69177C10.799 1.68434 10.8439 1.69261 10.8821 1.71512C10.9203 1.73763 10.9492 1.77293 10.9638 1.81475L11.5318 3.43587L12.0995 1.81475C12.1141 1.77293 12.1431 1.73763 12.1813 1.71512C12.2194 1.69261 12.2643 1.68434 12.308 1.69177C12.3517 1.69921 12.3913 1.72187 12.4199 1.75575C12.4484 1.78962 12.4641 1.83251 12.464 1.87681L12.4648 4.01413Z" fill="#12344D"/>
                  </svg>
                  
                
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div class="d-flex justify-content-between">
        <div class="SectionHeading">&nbsp;MF Forms</div>
        <div class="BackBtn" (click)="Back()">< Back</div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <iframe
            class="w-100 IFrameSection"
            src="https://gosite.co.in/mf-forms/index2.html"
            frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
